<template>
    <div class="home">
        <OrderSection />
    </div>
</template>

<script>
// @ is an alias to /src
import OrderSection from "@/components/OrderSection.vue";

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "employee",
    components: {
        OrderSection,
    },
};
</script>
